import { useState, useEffect } from 'react';
export function usePreferredImageIndex(images, dependencies = []) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    useEffect(() => {
        if (!images || images.length === 0) {
            setSelectedIndex(0);
            return;
        }
        const leftImageIndex = images.findIndex((img) => img.viewCategory === 'LEFT');
        if (leftImageIndex !== -1) {
            setSelectedIndex(leftImageIndex);
            return;
        }
        const rightImageIndex = images.findIndex((img) => img.viewCategory === 'RIGHT');
        if (rightImageIndex !== -1) {
            setSelectedIndex(rightImageIndex);
            return;
        }
        setSelectedIndex(0);
    }, [...dependencies, images?.length]);
    return [selectedIndex, setSelectedIndex];
}
